import invoke from '@hc-frontend/shared-assets/src/js/utils/fp/invoke'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Callback = (...args: any[]) => void

function initLoadingProgress(steps, progressId = '#loading-progress') {
  let width
  const widthRate = 100 / steps
  const $loadingProgress = $(progressId)
  if (
    $loadingProgress &&
    $loadingProgress.length !== 0 &&
    !$loadingProgress[0].style.transition
  ) {
    $loadingProgress.css({
      '-webkit-transition': 'width 0.6s ease',
      '-o-transition': 'width 0.6s ease',
      transition: 'width 0.6s ease'
    })
  }

  function updateLoadingProgress(data?: JSONValue, callback?: Callback) {
    width = width ? width + widthRate : widthRate

    if (callback) {
      $loadingProgress.one(
        // cspell:disable-next-line
        'transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd',
        invoke(callback)
      )
    }

    $loadingProgress.css({ width: `${width}%` })

    return data
  }

  return updateLoadingProgress
}

export default initLoadingProgress
